import DefaultLayout from '@/layouts/default.tsx';
import PaperContainer from '@/components/PaperContainer/PaperContainer.tsx';
import Container from '@/components/Container/Container.tsx';

import Progression from './Progression.tsx';
import ProgressionSettings from './ProgressionSettings.tsx';
import ProgressionOptions from './ProgressionOptions.tsx';
import ProgressionHelp from './ProgressionHelp.tsx';

function ProgressionsPage() {
    return (
    <DefaultLayout>
      <ProgressionSettings />
      <PaperContainer>
        <Container className="flex-col flex sm:flex-row justify-between items-start">
          <ProgressionOptions />
          <ProgressionHelp />
        </Container>
      </PaperContainer>
      <Progression />
    </DefaultLayout>
  );
}

export default ProgressionsPage;
